module.exports = __webpack_public_path__ + "static/valueQuality-5f0170dc73fbae576c2a40c98a73753e.png";